/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Modal from "react-modal";
import { theme } from "styles/theme";
import Button from "uis/Button";

type Props = {
    modalIsOpen: boolean;
    closeModal: () => void;
    title?: string;
    description?: JSX.Element;
    onHandleConfirm?: () => void;
};

Modal.setAppElement("#root");

const modalStyle = {
    content: {
        width: 502,
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        padding: "40px 30px",
        transform: "translate(-50%, -50%)",

        borderRadius: "15px",
    },
    overlay: {
        backgroundColor: "var(--component-color-material-dimmer)",
        zIndex: 1000,
    },
};

const Title = styled.p`
    font-size: 24px;
    font-weight: 700;
    text-align: center;
`;

const Description = styled.p`
    line-height: 140%;
    font-weight: 500;
    font-size: 20px;
    color: ${theme.neutral600};
    text-align: center;
`;

const BtnGroup = styled.div`
    display: flex;
    gap: 20px;
`;

const ChangeVisitStatusModal = (props: Props) => {
    const { modalIsOpen, closeModal, title, description, onHandleConfirm } = props;
    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 30px;
                `}
            >
                <Title>{title}</Title>
                <Description>{description}</Description>

                <BtnGroup>
                    <Button
                        onClick={closeModal}
                        title="취소"
                        type="secondary"
                        styles={{
                            container: css`
                                flex: 1;
                                padding: 16px 0;
                            `,
                        }}
                    />
                    <Button
                        onClick={onHandleConfirm}
                        title="확인"
                        styles={{
                            container: css`
                                flex: 1;
                                padding: 16px 0;
                            `,
                        }}
                    />
                </BtnGroup>
            </div>
        </Modal>
    );
};

export default ChangeVisitStatusModal;
